/* eslint-disable max-len */
//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//

export const zoneAliasRaw = 'SystemV/AST4:America/Puerto_Rico|SystemV/AST4ADT:America/Halifax|SystemV/CST6:America/Regina|SystemV/CST6CDT:America/Chicago|SystemV/EST5:America/Indianapolis|SystemV/EST5EDT:America/New_York|SystemV/HST10:Pacific/Honolulu|SystemV/MST7:America/Phoenix|SystemV/MST7MDT:America/Denver|SystemV/PST8:Pacific/Pitcairn|SystemV/PST8PDT:America/Los_Angeles|SystemV/YST9:Pacific/Gambier|SystemV/YST9YDT:America/Anchorage';
